import { LifePart } from "@/state/LifePart";
import React from "react";

export interface IGoalContextData {
    currentPart: LifePart | null
}

export interface IGoalScreenContext extends IGoalContextData {
    update: (update: Partial<IGoalContextData>) => void
}

export const GoalScreenContext = React.createContext<IGoalScreenContext>({ currentPart: null, update: (update)=> null});